import { useMemo, useCallback } from 'react'
import { useHistory } from 'react-router-dom'
import { v4 as uuidv4 } from 'uuid'
import { FormattedMessage } from 'react-intl'
import { isAuthenticated } from '../../../helpers'

export const useTournamentNavigation = (tournament, id) => {
  const history = useHistory()

  const navList = useMemo(
    () => [
      {
        id: uuidv4(),
        title: (
          <FormattedMessage id='tournaments.details.info.tabs.information' />
        ),
        to: `/battleCup/${id}/information`,
      },
      {
        id: uuidv4(),
        title: <FormattedMessage id='tournaments.details.info.tabs.brackets' />,
        to:
          tournament?.stages?.length > 1
            ? `/battleCup/${id}/bracket/group_stage`
            : `/battleCup/${id}/bracket/play_off`,
        to1:
          tournament?.stages?.length > 1
            ? `/battleCup/${id}/bracket/group_stage`
            : `/battleCup/${id}/bracket/play_off`,
      },
      {
        id: uuidv4(),
        title: <FormattedMessage id='game.tournaments.details.rules' />,
        to: `/battleCup/${id}/rules`,
      },
      {
        id: uuidv4(),
        title: <FormattedMessage id='tournaments.details.info.tabs.matches' />,
        to: `/battleCup/${id}/matches`,
      },
      {
        id: uuidv4(),
        title: (
          <FormattedMessage id='tournaments.details.info.tabs.participants' />
        ),
        to: `/battleCup/${id}/participants`,
      },
    ],
    [id, tournament?.stages?.length]
  )

  const goToUrl = useCallback(
    url => {
      history.push(url)
      if (!isAuthenticated()) {
        localStorage.removeItem('eventId')
        localStorage.removeItem('communityId')
        localStorage.removeItem('profileUrl')
        return localStorage.setItem('tournamentId', id)
      }
    },
    [history, id]
  )

  const handleEventClick = useCallback(() => {
    goToUrl(`/eventPage/${tournament?.event?.id}`)
  }, [goToUrl, tournament?.event?.id])

  const handleLoginClick = useCallback(() => {
    goToUrl('/login')
  }, [goToUrl])

  const handleProfileSettingsClick = useCallback(() => {
    goToUrl('/profile/settings')
  }, [goToUrl])

  return {
    navList,
    goToUrl,
    handleEventClick,
    handleLoginClick,
    handleProfileSettingsClick,
  }
}
